import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Navbar, Queue, ModalWrapper } from 'components'
import { useTranslation } from 'react-i18next'
import SettingActions from 'reducers/Setting'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import ReleaseActions from 'reducers/Releases'
import { useTheme } from 'styled-components'
import {
  MaterialIcon,
  LogoPlayerFullWhite,
  Text
} from '@dsny/dsny-component-library'

import {
  useDesktopMediaQuery,
  useMobileMediaQuery
} from 'utils/hooks/useMediaQueries'
import styles from './Sidebar.module.scss'

const Sidebar = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const isDesktop = useDesktopMediaQuery()
  const isMobile = useMobileMediaQuery()
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const isResponsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2
  const { t } = useTranslation()

  const handleSidebarClose = useCallback(() => {
    dispatch(SettingActions.closeTabletSidebar())
  }, [])

  const afterClick = useCallback(() => {
    dispatch(ReleaseActions.toggleReleaseInModal(null))
    isMobile && handleSidebarClose()
  }, [])

  const handleLogoClick = useCallback(() => {
    dispatch(ReleaseActions.setReleaseGalleryScrollPosition(0))
  }, [])

  return (
    <ModalWrapper
      className={[
        styles.sideBarWrapper,
        isResponsiveBreakpointsV2 && styles.responsiveBreakpointsV2
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        backgroundColor: theme.colors?.neutralW20,
        borderRightColor: theme.colors?.neutralW30
      }}
    >
      <div style={{ marginBottom: 40, padding: '40px 24px 0 24px' }}>
        <div className={styles.logoRow}>
          <NavLink
            to="/releases"
            onClick={handleLogoClick}
            className="flex focus:outline-none"
          >
            <LogoPlayerFullWhite className={styles.mainLogo} />
          </NavLink>
          {!isDesktop && (
            <button
              type="button"
              className="focus:outline-none"
              onClick={handleSidebarClose}
            >
              <MaterialIcon
                name="X"
                style={{ width: 9, height: 9 }}
                color={theme.colors.neutralW90}
              />
            </button>
          )}
        </div>

        <Navbar afterClick={afterClick} />
        <div style={{ borderBottom: `1px solid ${theme.colors.neutralW30}` }} />
      </div>
      <Queue />
    </ModalWrapper>
  )
}

Sidebar.propTypes = {
  history: PropTypes.object
}

export default Sidebar
